import React from 'react'

const Footer = () => {
  return (
    <div className='text-center text-md py-2 px-4'>
        Developed by @Gaurav Chakrawarti | 2025
    </div>
  )
}

export default Footer
